import { application } from '../application';
import ChartingHighchartsCategoricalController from './charting_highcharts_categorical_controller';
import ChartingHighchartsPointController from './charting_highcharts_point_controller';
import ChartingHighchartsSegmentController from './charting_highcharts_segment_controller';
import ChartingHighchartsGridController from './charting_highcharts_grid_controller';
import ChartingHighchartsHierarchyController from './charting_highcharts_hierarchy_controller';
import ChartingHighchartsLinkController from './charting_highcharts_link_controller';
import ChartingHighchartsNetworkgraphController from './charting_highcharts_networkgraph_controller';
import ChartingHighchartsRangeController from './charting_highcharts_range_controller';
import ChartingHighchartsScalarController from './charting_highcharts_scalar_controller';

application.register('charting-highcharts-categorical', ChartingHighchartsCategoricalController);
application.register('charting-highcharts-point', ChartingHighchartsPointController);
application.register('charting-highcharts-segment', ChartingHighchartsSegmentController);
application.register('charting-highcharts-grid', ChartingHighchartsGridController);
application.register('charting-highcharts-hierarchy', ChartingHighchartsHierarchyController);
application.register('charting-highcharts-link', ChartingHighchartsLinkController);
application.register('charting-highcharts-networkgraph', ChartingHighchartsNetworkgraphController);
application.register('charting-highcharts-range', ChartingHighchartsRangeController);
application.register('charting-highcharts-scalar', ChartingHighchartsScalarController);
